module.exports = __webpack_public_path__ + "media/images/driver-avatar-ea713f5ca8dc55ca7ac22facdb79b7da.svg";